export default (props) => (
  /**
   * Ícone de um filtro, cor parametrizada.
   * Encontrado na tabela de atributos
   */

<svg 
width="16" 
height="16" 
viewBox="0 0 16 16" 
fill="none" 
xmlns="http://www.w3.org/2000/svg"
{...props}
>
<path fillRule="evenodd" clipRule="evenodd" d="M0.951252 4.34398C0.81312 4.16165 0.848953 3.90186 1.03129 3.76373C1.10327 3.7092 1.19109 3.67969 1.2814 3.67969H12.0402C12.2689 3.67969 12.4544 3.86513 12.4544 4.09387C12.4544 4.18418 12.4249 4.272 12.3703 4.34398L7.69626 10.5138V15.2623C7.69626 15.3441 7.67205 15.424 7.6267 15.4921C7.49981 15.6824 7.24265 15.7338 7.05232 15.607L5.80976 14.7786C5.69454 14.7018 5.62533 14.5724 5.62533 14.434V10.5138L0.951252 4.34398Z" fill={props.fill ? props.fill : 'currentColor'}/>
<path fillRule="evenodd" clipRule="evenodd" d="M8.26609 0.320312H7.31641C6.76412 0.320312 6.31641 0.768028 6.31641 1.32031V2.22003H7.81641V1.82031H8.26609V0.320312ZM10.1655 0.320312V1.82031H12.0648V0.320312H10.1655ZM13.9642 0.320312V1.82031H14.4139V2.22003H15.9139V1.32031C15.9139 0.768028 15.4662 0.320312 14.9139 0.320312H13.9642ZM15.9139 4.01948H14.4139V5.81892H15.9139V4.01948ZM15.9139 7.61837H14.4139V9.41781H15.9139V7.61837ZM15.9139 11.2173H14.4139V11.617H13.9642V13.117H14.9139C15.4662 13.117 15.9139 12.6693 15.9139 12.117V11.2173ZM12.0648 13.117V11.617H10.1655V13.117H12.0648Z" fill={props.fill ? props.fill : 'currentColor'}/>
</svg>
);
